$(document).find('.js_goods').each((i, el) => {
    sliderInit(el)
})

$(window).on('resize', function () {
    sliderVertical()
})

function sliderInit(el) {
    let slides = +$(el).attr('data-count')
    let buttonNext = $(el).closest('.js_goods__container').find('.js_goods__btn-next')
    let buttonPrev = $(el).closest('.js_goods__container').find('.js_goods__btn-prev')
    let pagination = $(el).closest('.js_goods__container').find('.js_global-slider__pagination')
    let count = [1, 2, 3, 4, slides]
    if ($(el).closest('.js_modal-cart').length) {
        count = [1, 2, 2, 2, 2]
    }
    new Swiper(el, {
        autoHeight: false,
        loop: true,
        slidesPerView: count[0],
        spaceBetween: 20,
        breakpoints: {
            568: {
                slidesPerView: count[1],
            },
            768: {
                slidesPerView: count[2],
            },
            1024: {
                slidesPerView: count[3],
            },
            1536: {
                slidesPerView: count[4],
            }
        },
        navigation: {
            nextEl: buttonNext[0],
            prevEl: buttonPrev[0],
        },
        pagination: {
            el: pagination[0],
            clickable: true,
            bulletClass: 'global-slider__pagi-item',
            bulletActiveClass: 'global-slider__pagi-item_active'
        },
        modules: [SwiperModes.Navigation, SwiperModes.Pagination],
        centerInsufficientSlides: true,
        on: {
            init: function () {
                sliderVertical()
            }
        }
    })
}

window.sliderInit = sliderInit

function sliderVertical() {
    $('.js_slider-vertical').each((i, el) => {
        let maxHeightTitle = 0
        let maxHeightPrice = 0
        $(el).find('.js_slider-vertical-name').removeAttr('style')
        $(el).find('.js_slider-vertical-price').removeAttr('style')
        $(el).find('.js_slider-vertical-name').each((index, elem) => {
            if ($(elem).innerHeight() > maxHeightTitle) {
                maxHeightTitle = Math.ceil($(elem).innerHeight())
            }
        })
        $(el).find('.js_slider-vertical-price').each((index, elem) => {
            if ($(elem).innerHeight() > maxHeightPrice) {
                maxHeightPrice = Math.ceil($(elem).innerHeight())
            }
        })
        $(el).find('.js_slider-vertical-name').each((index, elem) => {
            $(elem).css('height', maxHeightTitle)
        })
        $(el).find('.js_slider-vertical-price').each((index, elem) => {
            $(elem).css('height', maxHeightPrice)
        })
    })
}

window.sliderVertical = sliderVertical